import type { Card, CardAction } from "../../types/chat";
import { SearchResultsCard } from "./SearchResultsCard";
import { EventPreviewCard } from "./EventPreviewCard";
import { FileCard } from "./FileCard";
import { SummaryCard } from "./SummaryCard";
import { ErrorCard } from "./ErrorCard";
import { ReportCard } from "./ReportCard";
import { ProposalCard } from "../../../tasks/mochi/ProposalCard";
import { TasksListCard, type TasksListData } from "../../../tasks/mochi/TasksListCard";
import type { Proposal } from "../../../tasks/mochi/api";

interface CardRendererProps {
  cards: Card[];
  onAction: (action: CardAction) => void;
}

export function CardRenderer({ cards, onAction }: CardRendererProps) {
  if (cards.length === 0) return null;

  return (
    <div className="flex flex-col gap-2 my-2">
      {cards.map((card, i) => {
        switch (card.type) {
          case "email_preview":
          case "search_results":
            return <SearchResultsCard key={i} card={card} onAction={onAction} />;
          case "event_preview":
            return <EventPreviewCard key={i} card={card} onAction={onAction} />;
          case "file":
            return <FileCard key={i} card={card} onAction={onAction} />;
          case "summary":
            return <SummaryCard key={i} card={card} />;
          case "report":
            return <ReportCard key={i} card={card} />;
          case "error":
            return <ErrorCard key={i} card={card} />;
          // Epic 13 — Mochi for Tasks.
          case "tasks_proposal":
            return <ProposalCard key={i} proposal={card.data as unknown as Proposal} />;
          case "tasks_list":
            return <TasksListCard key={i} data={card.data as unknown as TasksListData} />;
          default:
            return null;
        }
      })}
    </div>
  );
}
